import {
	AfterViewInit,
	Component,
	ElementRef,
	NgZone,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { HeaderProvider } from '@application/header_context';
import { UniversalConfig } from '@application/universal_config.service';
import { LayoutOutlet } from '@component/layout_outlet';
import { NhsAppProvider } from '@component/nhs_context/nhs_context';
import { ProgrammaticBrowserRouter } from '@cortex-shim/programmatic_browser_router.component';
import { LocationSelectorService } from '@public/src/application/services/location_selector.service';
import { sharedResolution } from '@public/src/shared_resolution';
import { createRoot, Root } from 'react-dom/client';
import { Route, Routes } from 'react-router';
import { ViewCareNavigation } from '../../../patient/src/views/view_care_navigation/view_care_navigation.component';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'reactCareNavigationRedirectComponent';

@Component({
	standalone: false,
	selector: 'care-navigation-component',
	template: `
		<semantic-view hideOnMobile="true">
		<header-component header></header-component>
			<div class="wrapper-container" #${containerElementName}></div>
			<footer-component footer></footer-component>
		</semantic-view>
	`,
	encapsulation: ViewEncapsulation.None,
})
export class CareNavigationWrapper implements OnChanges, OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(private readonly ngZone: NgZone) {}

	ngOnChanges(_: SimpleChanges): void {
		// noop
	}

	ngAfterViewInit() {
		this.render();
	}

	ngOnDestroy() {
		this.root?.unmount();
	}

	private render() {
		if (this.containerRef?.nativeElement == null) {
			return;
		}

		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);
		const universalConfigService = sharedResolution.resolve(UniversalConfig);

		if (this.root == null) {
			this.root = createRoot(this.containerRef.nativeElement);
		}

		const split = locationSelectorService.location.route.split('/');
		split.splice(0, 1);
		const routeBase = split.join('/');

		this.ngZone.runOutsideAngular(() => {
			this.root.render(
				<CellulaProviderWrapper useGlobals>
					<NhsAppProvider>
						<HeaderProvider>
							<ProgrammaticBrowserRouter basename={universalConfigService.alias} forceNewHistory>
								<Routes>
									<Route path={routeBase} element={<LayoutOutlet.Flow hideHeader />}>
										<Route path='navigation/*' element={<ViewCareNavigation />} />
									</Route>
								</Routes>
							</ProgrammaticBrowserRouter>
						</HeaderProvider>
					</NhsAppProvider>
				</CellulaProviderWrapper>,
			);
		});
	}
}
